// extracted by mini-css-extract-plugin
export default {"base":"PasswordRequirements_base__T18Ha","block":"PasswordRequirements_block__fvcYb","item":"PasswordRequirements_item__BNoNU","done":"PasswordRequirements_done__rBRI4"};